var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavouriteBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mwela",
    d: "M943 675c0-3.53 2.471-6 6-6h26c3.529 0 6 2.47 6 6v26c0 3.53-2.471 6-6 6h-26c-3.529 0-6-2.47-6-6v-26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mwelb",
    d: "M962 678.5l3.111 6.923 7.389.577-5.5 5 1.5 7.5-6.5-3.846-6.5 3.846 1.5-7.5-5.5-5 7.388-.577L962 678.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-942 -668)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#mwela"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillOpacity: 0,
    stroke: "#1f76ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    strokeWidth: 2,
    xlinkHref: "#mwelb"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteBlue);
export default __webpack_public_path__ + "static/media/favourite-blue.798762360d472b864db4d786c5cba982.svg";
export { ForwardRef as ReactComponent };